import React, { useState } from 'react';
import logo from '../images/logo.webp';
import { signin, resetMessage } from '../../Redux/features/auth/authSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const Login = () => {
	const [MobileNo, setMobileNo] = useState(''); // Username from user input
	const [UserPassword, setUserPassword] = useState(''); // Password from user input
	const dispatch = useDispatch();
	const [error, setError] = useState(null);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!MobileNo || !UserPassword) {
			toast.error('Please provide all the details');
			return; // Stop the execution if required fields are missing
		}

		setError(null); // Reset error state before submitting

		// Dispatch the signin action
		try {
			const response = await dispatch(signin({ MobileNo, UserPassword }));

			// Handle the response after signin
			if (response.error) {
				toast.error(response.payload); // Show error message from the API response
				dispatch(resetMessage()); // Reset message after error
			} else {
				toast.success(response.payload.message); // Success message from API response

				// Check user role from response payload
				if (response.payload.user === 'ADMIN') {
					// Fetch admin details if user is admin
					window.location.href = '/adminhome';
				} else if (response.payload.user === 'USER') {
					// Fetch user details if user is regular user
					window.location.href = '/dashboard';
				} else {
					// Reset message if role is neither admin nor user
					dispatch(resetMessage());
				}
			}
		} catch (error) {
			toast.error('An error occurred during login');
			dispatch(resetMessage());
		}
	};

	return (
		<>
			<div className='flex justify-center items-center md:mt-10 mt-2 py-10'>
				<img src={logo} alt='Logo' className=' my-4' />
			</div>
			<div className='flex flex-col items-center justify-center'>
				<p className='uppercase md:mb-8 mb-4 text-xl md:text-2xl font-semibold'>Login</p>
				<form
					className='lg:w-[25%] md:w-1/2 w-[90%] bg-white rounded-xl shadow-xl px-6 md:px-10 py-5'
					onSubmit={handleSubmit}>
					<div>
						<label className='text-sm md:text-base'>Mobile Number</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							type='text'
							value={MobileNo}
							onChange={(e) => setMobileNo(e.target.value)}
							placeholder='MobileNo'
							required
						/>
					</div>
					<div>
						<label className='text-sm md:text-base'>Password</label>
						<input
							className='w-full bg-gray-100 text-gray-900 md:mt-3 mt-2 md:mb-4 mb-2 md:p-3 p-2 shadow-lg rounded'
							type='password'
							value={UserPassword}
							onChange={(e) => setUserPassword(e.target.value)}
							placeholder='Enter Your Password'
							required
						/>
					</div>
					{error && <p className='text-red-500'>{error}</p>} {/* Display error message */}
					<div className=' flex  w-full flex-col text-center mt-5'>
						<button type='submit' className='proBtn w-full rounded-none '>
							Login
						</button>
						<Link to={'/signup'} className='mt-2'>
							Don&apos;t have an account?
							<span className=' font-semibold hover:text-red-500'>SignUp</span>
						</Link>
					</div>
				</form>
			</div>
		</>
	);
};

export default Login;
